import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash.merge';
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Label from '../Label';
import { muiGlobalTheme } from '../FormElements.theme';

function Checkbox({ label, customLabel, description, toolTip, noLabelMargins, onChange, name, ...other }) {
  const checkboxTheme = useMemo(() => {
    const theme = { ...muiGlobalTheme };

    theme.overrides = merge(theme.overrides, {
      MuiCheckbox: {
        root: {
          height: 44,
          marginBottom: 0
        }
      },
      MuiFormControlLabel: {
        root: {
          alignItems: 'center',
          marginRight: noLabelMargins ? '0px' : '16px'
        }
      }
    });

    return createTheme(adaptV4Theme(theme));
  }, []); // The theme is created once and memoized

  const handleOnChange = (event, newChecked) => {
    onChange({ target: { name, value: newChecked, checked: newChecked, stringValue: event?.target?.value ?? '' } });
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={checkboxTheme}>
        <FormControlLabel
          control={<MuiCheckbox {...other} onChange={handleOnChange} name={name} color="primary" />}
          label={customLabel || <Label label={label} description={description} toolTip={toolTip} />}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

Checkbox.propTypes = {
  /** Optional title that appears above label  */
  description: PropTypes.string,
  /** Optional prop for passing tooltip component  */
  toolTip: PropTypes.node,
  /** Optional prop for passing custom label fragment / component  */
  customLabel: PropTypes.node,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired
};

Checkbox.defaultProps = {
  onChange: () => {},
  description: undefined,
  toolTip: null,
  customLabel: undefined
};

export default memo(Checkbox);
